import { useForm } from "@inertiajs/react";
import Button from "@/components/ui/Button";
import { Field, Input } from "@/components/ui/Field";

export default function TransferForm({ user_id }: { user_id: number }) {
  const { data, setData, post, processing, reset } = useForm({
    amount: 0,
    slack_id: "",
    reason: "",
  });

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    if (
      confirm(
        `Are you sure you want to transfer ${data.amount} ticket${data.amount === 1 ? "" : "s"} to the user with slack ID ${data.slack_id}? Once approved, this is irreversible.`,
      )
    ) {
      post(`/users/${user_id}/transfers`);
      reset();
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="border-line/20 flex flex-col gap-4 border-t-2 pt-4"
    >
      <p className="font-display text-subheading text-ink font-bold">
        New transfer
      </p>

      <Field
        label="User Slack ID"
        hint={
          <>
            Ping them in{" "}
            <a
              className="text-link underline"
              href="https://hackclub.enterprise.slack.com/archives/C0159TSJVH8"
            >
              #what-is-my-slack-id
            </a>
            .
          </>
        }
      >
        <Input
          value={data.slack_id}
          onChange={(e) => setData("slack_id", e.target.value)}
          required
        />
      </Field>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Field label="Amount">
          <Input
            type="number"
            value={data.amount}
            onChange={(e) => setData("amount", Number(e.target.value))}
            required
            min="1"
            step="1"
          />
        </Field>

        <Field label="Reason">
          <Input
            value={data.reason}
            onChange={(e) => setData("reason", e.target.value)}
            required
          />
        </Field>
      </div>

      <Button type="submit" className="w-fit" disabled={processing}>
        {processing ? "Requesting…" : "Request transfer"}
      </Button>
    </form>
  );
}
